import fetchClient, { ApiResponse } from '../api-client'
import { CreatePickupOrderPayload, PickupOrderStatus } from './types/PickupOrder'
import { PickupOrder } from './types/PickupOrder'

/**
 * Create a new pickup order
 */
export const createPickupOrder = async (data: CreatePickupOrderPayload): Promise<PickupOrder> => {
  try {
    const formData = new FormData()
    formData.append('pickupDate', data.pickupDate)
    formData.append('orderNumber', data.orderNumber)
    formData.append('barcodeFile', data.barcodeFile)

    // Don't set Content-Type header - axios will set it automatically with boundary for FormData
    const res = await fetchClient.post<ApiResponse<PickupOrder>>(`/pickup-orders`, formData)
    if (!res.data.data) {
      throw new Error('Failed to create pickup order')
    }
    return res.data.data
  } catch (err) {
    console.error('createPickupOrder error:', err)
    throw err
  }
}

/**
 * Get all pickup orders with optional filtering
 */
export const getPickupOrders = async (filters?: { status?: string }): Promise<PickupOrder[]> => {
  try {
    const params = new URLSearchParams()
    if (filters?.status) params.append('status', filters.status)

    const queryString = params.toString()
    const url = queryString ? `/pickup-orders?${queryString}` : '/pickup-orders'
    const res = await fetchClient.get<ApiResponse<PickupOrder[]>>(url)
    return res.data.data || []
  } catch (error) {
    throw error
  }
}

/**
 * Get a single pickup order by ID
 */
export const getPickupOrder = async (id: string): Promise<PickupOrder> => {
  try {
    const res = await fetchClient.get<ApiResponse<PickupOrder>>(`/pickup-orders/${id}`)
    return res.data.data
  } catch (error) {
    throw error
  }
}

/**
 * Update a pickup order
 */
export const updatePickupOrder = async (id: string, data: { status: PickupOrderStatus }): Promise<PickupOrder> => {
  try {
    const res = await fetchClient.patch<ApiResponse<PickupOrder>>(`/pickup-orders/${id}`, data)
    if (!res.data.data) {
      throw new Error('Failed to update pickup order')
    }
    return res.data.data
  } catch (err) {
    console.error('updatePickupOrder error:', err)
    throw err
  }
}
